import React from 'react';
import Container from './blueprint/components/Container/Container';
import './scss/export-body.scss';

const InnerBody = props => (
  <main className="pdf-layout__body">
    <Container className="pt-0">{props.children}</Container>
  </main>
);

const Overflow = props => (
  <table className="layout-wrapper" style={{ width: '100%' }}>
    <thead>
      <tr>
        <td>
          <div className="pdf-layout__spacer pdf-layout__spacer--header" />
        </td>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>
          <InnerBody {...props} />
        </td>
      </tr>
    </tbody>

    {props.footerSpacer && (
      <tfoot>
        <tr>
          <td>
            <div className="pdf-layout__spacer pdf-layout__spacer--footer" />
          </td>
        </tr>
      </tfoot>
    )}
  </table>
);
// interface ExportBodyProps {
//   isOverflow: boolean;
//   footerSpacer: boolean;
// }
const ExportBody = ({ isOverflow, footerSpacer, ...props }) => {
  return isOverflow ? <Overflow {...props} /> : <InnerBody {...props} />;
};

ExportBody.defaultProps = {
  footerSpacer: true,
  isOverflow: false
};

export default ExportBody;
